import { api, cachedRequest } from '../apiClient';

export interface SearchResult {
  query: string;
  events: {
    results: any[];
    pagination: {
      current_page: number;
      total_pages: number;
      total_count: number;
      has_next: boolean;
      has_previous: boolean;
      next_page: number | null;
      previous_page: number | null;
    };
  };
  activities: {
    results: any[];
    pagination: {
      current_page: number;
      total_pages: number;
      total_count: number;
      has_next: boolean;
      has_previous: boolean;
      next_page: number | null;
      previous_page: number | null;
    };
  };
  filters: {
    category?: string;
    event_type?: string;
    country_code?: string;
  };
}

export interface SearchSuggestion {
  events: Array<{
    id: number;
    title: string;
    slug: string;
    venue_name: string | null;
    thumbnail_url: string | null;
  }>;
  activities: Array<{
    id: number;
    name: string;
    slug: string;
    location: string;
    thumbnail_url: string | null;
  }>;
}

export const searchService = {
  search: async (
    query: string,
    category?: string,
    eventType?: string,
    page: number = 1,
    forceRefresh: boolean = false
  ): Promise<SearchResult> => {
    const cacheKey = `search_${query}_${category || 'all'}_${eventType || 'all'}_${page}`;
    
    return cachedRequest(
      cacheKey,
      async () => {
        const params = new URLSearchParams({ q: query, page: page.toString() });
        if (category) params.append('category', category);
        if (eventType) params.append('event_type', eventType);

        const response = await api.get(`/search/?${params.toString()}`);
        return response.data;
      },
      2 * 60 * 1000, // 2 minutes
      forceRefresh
    );
  },

  getSearchSuggestions: async (query: string, forceRefresh: boolean = false): Promise<SearchSuggestion> => {
    if (query.length < 2) {
      return { events: [], activities: [] };
    }
    
    const cacheKey = `search_suggestions_${query}`;
    
    return cachedRequest(
      cacheKey,
      async () => {
        const response = await api.get(`/search-suggestions/?q=${encodeURIComponent(query)}`);
        return response.data;
      },
      1 * 60 * 1000, // 1 minute (shorter cache for suggestions)
      forceRefresh
    );
  },
};

